import api from "../../Api";
import { BaseService } from "../../BaseService";

const URL = "users";

export class UsersService extends BaseService {
  async list(params: any): Promise<any[]> {
    try {
      return this.handleResponse(await api.post(`${URL}/list`, params));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async fetch(params: any): Promise<any> {
    try {
      if (params?.id) {
        return this.handleResponse(await api.put(`${URL}/update`, params));
      } else {
        return this.handleResponse(await api.post(`${URL}/create`, params));
      }
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async delete(id: number): Promise<any> {
    try {
      return this.handleResponse(await api.delete(`${URL}/delete/${id}`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async reactivate(id: number): Promise<any> {
    try {
      return this.handleResponse(await api.post(`${URL}/reactivate/${id}`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async statusTutorial(): Promise<any> {
    try {
      return this.handleResponse(await api.get(`${URL}/status-tutorial`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async finishedTutorial(): Promise<any> {
    try {
      return this.handleResponse(await api.put(`${URL}/status-tutorial/1`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async completedToday(): Promise<any> {
    try {
      return this.handleResponse(
        await api.get(`${URL}/status-tutorial/completed-today`),
      );
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }
  async resetTutorial(): Promise<any> {
    try {
      return this.handleResponse(await api.put(`${URL}/status-tutorial/0`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async types(params?: any): Promise<any[]> {
    try {
      return this.handleResponse(await api.post(`${URL}/types/list`, params ?? {}));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async paymentsMethods(id: any): Promise<any> {
    try {
      return this.handleResponse(
        await api.get(`${URL}/payments/methods/payment-summary/${id}`),
      );
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }
}
